import { db } from "@/firebaseConfig";

const usersCollection = db.collection("users");

const saveUser = async (id, data) => {
  usersCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("User successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateUser = async (id, data) => {
  usersCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("User successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteUser = async id => {
  usersCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("User successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getUserById = async id => {
  return usersCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export { usersCollection, saveUser, updateUser, deleteUser, getUserById };
